module.exports = __webpack_public_path__ + "static/img/empty_1.d234d98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/empty_1.png
// module id = 1t/z
// module chunks = 87